const spaceId = process.env.CONTENTFUL_SPACE_ID;

const HTTPS_PREFIX = `https://assets.ctfassets.net/${spaceId}/`;
const PROTOCOL_RELATIVE_PREFIX = `//assets.ctfassets.net/${spaceId}/`;

/**
 * Rewrites Contentful asset URLs to the local /filer/ proxy path so users
 * see eesy.dk in the browser URL bar instead of assets.ctfassets.net.
 */
export function rewriteAssetUrl(url: string): string {
  if (url.startsWith(HTTPS_PREFIX)) {
    return `/filer/${url.slice(HTTPS_PREFIX.length)}`;
  }
  if (url.startsWith(PROTOCOL_RELATIVE_PREFIX)) {
    return `/filer/${url.slice(PROTOCOL_RELATIVE_PREFIX.length)}`;
  }
  return url;
}
